import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class ViewCloseGuard implements CanDeactivate<boolean> {
  constructor(private snackbarService: SnackbarService) {}

  canDeactivate(): boolean {
    // TODO - temporary - to check
    // this.snackbarService.dismiss();
    return true;
  }
}
